import PropTypes from 'prop-types'

import { H5, S05 } from '../../../../styles/typography'
import subscriptionFeatures from '../config/features'
import PricingStore from '../stores/pricing-store'

const Features = ({ filterNullValues }) => {
  const { showMonthly } = PricingStore.useContainer()

  return (
    <div className='features'>
      <div className='header'>
        <H5>Choose a plan</H5>
      </div>

      {subscriptionFeatures.map(({ id, name, condition }) =>
        filterNullValues && !condition({ showMonthly }) ? null : (
          <div key={id} className='row'>
            <S05>{name}</S05>
          </div>
        ),
      )}
    </div>
  )
}

export default Features

Features.propTypes = {
  filterNullValues: PropTypes.bool,
}
Features.defaultProps = {
  filterNullValues: false,
}
